<template lang="pug">
b-card
  validation-observer(ref="form", tag="form")
    b-form
      b-row
        // Name
        b-col(md="6")
          b-form-group(:label="$t('label.Name')", :label-for="$t('label.name')", description="")
            validation-provider(:name="$t('label.Name')", rules="required", v-slot="{ errors }")
              b-form-input#name(v-model="data.name", trim, :placeholder="$t('placeholder.name')")
              small(class="text-danger") {{ errors[0] }}
        // Email
        b-col(md="6")
          b-form-group(:label="$t('label.loginEmail')", :label-for="$t('label.email')", :description="$t('message.worker_login_email_desc')")
            validation-provider(:name="$t('label.loginEmail')", :rules="emailRules", v-slot="{ errors }")
              b-form-input#email(v-model="data.email", trim, :placeholder="$t('placeholder.email')")
              small(class="text-danger") {{ errors[0] }}
      b-row
        // Contact email
        b-col(md="6")
          b-form-group(:label="$t('label.contactEmail')", :label-for="$t('label.contactEmail')", :description="$t('message.worker_contact_email_desc')")
            validation-provider(:name="$t('label.contactEmail')", :rules="realEmailRules", v-slot="{ errors }")
              b-form-input#realEmail(v-model="data.realEmail", trim, :placeholder="$t('placeholder.email')")
              small(class="text-danger") {{ errors[0] }}
        //- b-col(:md="isPCUploadVisible ? '6' : '12'")
        b-col(md="6")
          // Locations
          b-form-group(
            :label="$t('label.Locations')",
            :label-for="$t('label.location')",
            :description="$t('message.worker_locations')"
          )
            v-select#location(
              v-model="data.locations",
              :reduce="(locations) => locations.value",
              :multiple="true",
              label="title",
              :options="locations",
              :placeholder="$t('placeholder.locations')",
              taggable,
              @option:created="onLocationCreated"
            )

        //- b-col(v-if="isPCUploadVisible", md="6")
          // Automatic P.C. Upload
          b-form-group(
            :label="$t('label.automatic_pc_upload')",
            :label-for="$t('label.automatic_pc_upload')",
            :description="$t('message.enable_automatic_pc_upload')"
          )
            v-select#pcupload(
              v-model="data.isPCUploadEnabled",
              :reduce="(options) => options.value",
              label="title",
              :options="[{ value: true, title: $t('message.yes') }, { value: false, title: $t('message.no') }]",
            )
      b-row
        // Complaint Management
        b-col(md="6")
          b-form-group(
            :label="$t('label.complaintManagement')",
            label-for="complaintManagement",
          )
          b-form-checkbox(v-model="data.isComplaintManager" :value="true" :unchecked-value="false" class="mt-1")
            | {{ $t('label.enabledToManageComplaints') }}
        // Roles
        b-col(md="6")
          b-form-group(
            :label="$t('label.Roles')",
            :label-for="$t('label.roles')",
            :description="$t('message.worker_roles')"
          )
            v-select#roles(
              v-model="data.roles",
              :reduce="(roles) => roles.value",
              :multiple="true",
              label="title",
              :options="roles",
              :placeholder="$t('placeholder.roles')",
              taggable,
              @option:created="onRoleCreated"
            )
      b-row
        // Privileges
        b-col(md="6")
          b-form-group(
            :label="$t('label.Privileges')",
            :label-for="$t('label.privileges')",
            :description="$t('message.worker_privileges')"
          )
            validation-provider(:name="$t('label.Privileges')", rules="required", v-slot="{ errors }")
              v-select#privileges(
                v-model="data.privileges",
                :reduce="(privileges) => privileges.value",
                label="title",
                :options="privileges",
                :placeholder="$t('placeholder.privileges')"
              )
              small(class="text-danger") {{ errors[0] }}
        // Company
        b-col(md="6")
          b-form-group(
            :label="$t('label.Company')",
            :label-for="$t('label.company')"
          )
            v-select#company(
              v-model="data.company",
              :reduce="(companies) => companies.value",
              :multiple="true",
              label="title",
              :options="companies",
              :placeholder="$t('placeholder.companies')",
              taggable,
              @option:created="onCompanyCreated"
            )
      b-row
        // Supervisor
        b-col(md="6")
          b-form-group(
            :label="$t('label.Supervisors')",
            :label-for="$t('label.supervisors')",
            :description="$t('message.supervisor_desc')"
          )
            v-select#supervisor(
              v-model="data.supervisors",
              :reduce="(supervisors) => supervisors.value",
              :multiple="true",
              label="title",
              :options="supervisors",
              :selectable="worker => !worker.deleted",
              :placeholder="$t('placeholder.supervisors')"
            )

      b-row
        b-col.text-right(cols="12")
          b-button(variant="success", :disabled="isSubmitting", @click="validateAndSubmit")
            | {{ $t('message.submit') }}

  audit-log-table(
    v-if="isEdit && data",
    :history="data.history || []",
    :field-translations="{ name: $t('label.Name'), email: $t('label.loginEmail'), realEmail: $t('label.contactEmail'), locations: $t('label.Locations'), roles: $t('label.Roles'), privileges: $t('label.Privileges'), supervisors: $t('label.Supervisors'), isComplaintManager: $t('label.complaintManagement'), company: $t('label.Company') }"
  )
</template>

<script>
import vSelect from 'vue-select'
import { onMounted, ref, toRefs, computed } from '@vue/composition-api/dist/vue-composition-api'
import useCommon from '../../useCommon'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from "@validations";
import useNotifications from '@/composables/useNotifications'
import i18n from '@/libs/i18n'
import { BFormCheckbox } from "bootstrap-vue";
import AuditLogTable from '@/components/AuditLogTable.vue'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import store from '@/store'

export default {
  name: 'Form',

  components: {
    vSelect,
    ValidationObserver,
    ValidationProvider,
    BFormCheckbox,
    AuditLogTable,
  },

  props: {
    data: { type: Object, required: true },
    isSubmitting: { type: Boolean, default: false },
    isPCUploadVisible: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false },
  },

  setup(props, { emit }) {
    const { showSuccessMessage, showErrorMessage } = useNotifications()
    const { getRolesForDropDown, roles, getSupervisorsForDropDown, supervisors, getLocationsForDropDown, locations, getPrivilegesForWorker, workerPrivileges, getCompaniesForDropDown, companies } = useCommon()
    const { createItem } = useLambda()
    const userData = store.state?.userStore?.userData
    const form = ref(null)

    const emailRules = computed(() => {
      let rules = 'email'
      if (props.data.privileges !== 'employee') rules += '|required'
      return rules
    })

    const realEmailRules = 'email'

    const validateForm = () => new Promise((resolve, reject) => {
      form.value.validate().then(success => {
        if (success) resolve(true)
        else reject()
      })
    })

    const validateAndSubmit = () => {
      validateForm()
        .then(() => {
          const loginEmail = (props.data.email || '').trim().toLowerCase()
          const contactEmail = (props.data.realEmail || '').trim().toLowerCase()
          if (contactEmail && contactEmail === loginEmail) {
            showErrorMessage(i18n.t('message.real_email_same_as_login'))
            return
          }
          emit('submit', toRefs(props.data))
        })
        .catch(() => showErrorMessage(i18n.t('message.requiredFieldsIncomplete')))
    }

    const onLocationCreated = async (newLocation) => {
      try {
        // newLocation can be either a string or an object with .title
        const locationName = typeof newLocation === 'string' ? newLocation : newLocation.title

        const payload = {
          location: locationName,
          client_id: oid(userData.client.$oid),
        }

        const { insertedId } = await createItem({ collection: 'location', payload })
        const newId = insertedId.toString()

        // Add to local list
        locations.value.push({ title: locationName, value: newId })

        // Remove any null/undefined values and the string if it exists
        if (!props.data.locations) props.data.locations = []
        props.data.locations = props.data.locations.filter(loc => loc !== null && loc !== undefined && loc !== locationName)

        // Add the new ID
        props.data.locations.push(newId)

        showSuccessMessage(i18n.t('message.location_added'))
      } catch (error) {
        console.error(error)
        showErrorMessage(i18n.t('message.location_add_error'))
      }
    }

    const onRoleCreated = async (newRole) => {
      try {
        // newRole can be either a string or an object with .title
        const roleName = typeof newRole === 'string' ? newRole : newRole.title

        const payload = {
          name: roleName,
          client_id: oid(userData.client.$oid),
        }

        const { insertedId } = await createItem({ collection: 'role', payload })
        const newId = insertedId.toString()

        // Add to local list
        roles.value.push({ title: roleName, value: newId })

        // Remove any null/undefined values and the string if it exists
        if (!props.data.roles) props.data.roles = []
        props.data.roles = props.data.roles.filter(role => role !== null && role !== undefined && role !== roleName)

        // Add the new ID
        props.data.roles.push(newId)

        showSuccessMessage(i18n.t('message.role_added'))
      } catch (error) {
        console.error(error)
        showErrorMessage(i18n.t('message.role_add_error'))
      }
    }

    const onCompanyCreated = async (newCompany) => {
      try {
        // newCompany can be either a string or an object with .title
        const companyName = typeof newCompany === 'string' ? newCompany : newCompany.title

        const payload = {
          name: companyName,
          client_id: oid(userData.client.$oid),
        }

        const { insertedId } = await createItem({ collection: 'company', payload })
        const newId = insertedId.toString()

        // Add to local list
        companies.value.push({ title: companyName, value: newId })

        // Remove any null/undefined values and the string if it exists
        if (!props.data.company) props.data.company = []
        props.data.company = props.data.company.filter(comp => comp !== null && comp !== undefined && comp !== companyName)

        // Add the new ID
        props.data.company.push(newId)

        showSuccessMessage(i18n.t('message.company_added'))
      } catch (error) {
        console.error(error)
        showErrorMessage(i18n.t('message.company_add_error'))
      }
    }

    onMounted(async () => {
      getRolesForDropDown()
      getSupervisorsForDropDown()
      getPrivilegesForWorker()
      getLocationsForDropDown()
      getCompaniesForDropDown()
    })

    return {
      roles,
      privileges: workerPrivileges,
      supervisors,
      locations,
      companies,
      required,
      form,
      validateAndSubmit,
      emailRules,
      realEmailRules,
      onLocationCreated,
      onRoleCreated,
      onCompanyCreated,
    }
  },
}
</script>

<style scoped>
</style>
